// extracted by mini-css-extract-plugin
export default {"notFound":"styles_notFound__vSPhr","notInfo":"styles_notInfo__Skfgv","notTitle":"styles_notTitle__lJDZA","notBlock":"styles_notBlock__nFd8b","notText":"styles_notText__nFH0p"};